
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/machinery-loans-for-exporters-india",
      function () {
        return require("private-next-pages/machinery-loans-for-exporters-india/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/machinery-loans-for-exporters-india"])
      });
    }
  